module.exports = __webpack_public_path__ + "static/media/CUYA_Web_LandingPage_CalloutPhoot_ChestPain.d74aa3b0.jpg";